import { FC, useState } from 'react'
import UserWebAPI from '../api/user_web_api'
import Status from '../constants/request_statuses'
import Button from './Button'

type UserDeleterProps = {
  userId: string | number
  className?: string
}

const UserDeleter: FC<UserDeleterProps> = ({ userId, className }) => {
  const [status, setStatus] = useState(Status.IDLE)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    deleteUser()
  }

  const handleSuccess = (res: { status: number }) => {
    const type = Math.floor(res.status / 100)
    type === 2 ? setStatus(Status.SUCCEEDED) : setStatus(Status.FAILED)
  }

  const handleError = () => {
    setStatus(Status.FAILED)
  }

  const getTextContent = () => {
    switch (status) {
      case Status.IDLE:
        return 'Delete user'
      case Status.LOADING:
        return 'Deleting...'
      case Status.FAILED:
        return 'Delete failed'
      case Status.SUCCEEDED:
        return 'Queued for deletion'
      default:
        return ''
    }
  }

  const deleteUser = () => {
    setStatus(Status.LOADING)
    UserWebAPI.deleteUser(userId).then(handleSuccess, handleError)
  }

  const text = getTextContent()

  return status === Status.IDLE ? (
    <Button onClick={handleClick} className={className} title="Delete user">
      {text}
    </Button>
  ) : (
    <span className={className}>{text}</span>
  )
}

export default UserDeleter
